import React, { useEffect } from 'react'
import { Tabs, Button, Divider } from 'antd';
import tractor1 from '../../images/tractor-1.jpg'
import tractor2 from '../../images/tractor-2.jpg'
import { Tooltip } from 'antd';




function StaticCompareTractors() {
    return (
        <div className="mt-16">
            <div className="p-4 m-4 rounded-lg shadow bg-white">
                <div className="p-2">
                    <h2 className="text-2xl font-bold border-b mb-3 pb-2 text-gray-700">Compare Tractors</h2>
                    
                        <div className="md:grid md:grid-cols-3 md:gap-5 flex items-center mt-4">
                            <div className="hidden md:flex md:justify-between items-center bg-white shadow rounded-lg hover:shadow-xl overflow-hidden cursor-pointer">
                                <div>
                                    <img className="h-40 w-48 object-cover py-2" src={tractor1} alt=""/>
                                    <div className="py-4 px-2">
                                        <p className="text-sm font-bold text-gray-700 text-center">
                                            <span className="uppercase tracking-wide"> Mahindra</span>
                                            <span className="ml-1">475 DI</span>
                                            <br/>
                                            <Tooltip title="PTO Horsepower"><span className="">55HP</span></Tooltip>
                                            <span className="m-1">•</span>
                                            <Tooltip title="Drive type"><span className="">4WD</span></Tooltip>
                                        </p>
                                    </div>
                                </div>
                                <div className="m-0">
                                    <h4 className="bg-purple-700 rounded-full text-white text-bold text-lg py-1 px-2">vs</h4>
                                </div>
                                <div>
                                    <img className="h-40 w-48 object-cover py-2" src={tractor2} alt=""/>
                                    <div className="py-4 px-2">
                                        <p className="text-sm font-bold text-gray-700 text-center">
                                            <span className="uppercase tracking-wide"> Mahindra</span>
                                            <span className="ml-1">475 DI</span>
                                            <br/>
                                            <Tooltip title="PTO Horsepower"><span className="">55HP</span></Tooltip>
                                            <span className="m-1">•</span>
                                            <Tooltip title="Drive type"><span className="">4WD</span></Tooltip>
                                        </p>
                                    </div>
                                </div>    
                            </div>

                            <div className="flex items-center justify-center bg-white shadow rounded-lg shadow hover:shadow-xl overflow-hidden cursor-pointer">
                                <div className="text-gray-400 hover:text-purple-700 hover:border-purple-700">
                                    <svg className="fill-current h-20 m-auto p-2 mt-10 mb-4 hover:border-purple-700 border-2 border-dashed rounded-full" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd"></path></svg>
                                    <p className="text-base py-4 px-2 text-center font-bold">
                                        <span className="uppercase"> Add to compare</span>
                                    </p>
                                </div>
                                <div className="m-2">
                                    <h4 className="bg-purple-700 rounded-full text-white text-bold text-lg py-1 px-2">vs</h4>
                                </div>
                                <div className="text-gray-400 hover:text-purple-700 hover:border-purple-700">
                                    <svg className="fill-current h-20 m-auto p-2 mt-10 mb-4 hover:border-purple-700 border-2 border-dashed rounded-full" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd"></path></svg>
                                    <p className="text-base py-4 px-2 text-center font-bold">
                                        <span className="uppercase"> Add to compare</span>
                                    </p>
                                </div>   
                            </div>


                            <div className="hidden md:flex md:justify-between items-center bg-white shadow rounded-lg hover:shadow-xl overflow-hidden cursor-pointer">
                                <div>
                                    <img className="h-40 w-48 object-cover py-2" src={tractor1} alt=""/>
                                    <div className="py-4 px-2">
                                        <p className="text-sm font-bold text-gray-700 text-center">
                                            <span className="uppercase tracking-wide"> Mahindra</span>
                                            <span className="ml-1">475 DI</span>
                                            <br/>
                                            <Tooltip title="PTO Horsepower"><span className="">55HP</span></Tooltip>
                                            <span className="m-1">•</span>
                                            <Tooltip title="Drive type"><span className="">4WD</span></Tooltip>
                                        </p>
                                    </div>
                                </div>
                                <div className="m-0">
                                    <h4 className="bg-purple-700 rounded-full text-white text-bold text-lg py-1 px-2">vs</h4>
                                </div>
                                <div>
                                    <img className="h-40 w-48 object-cover py-2" src={tractor2} alt=""/>
                                    <div className="py-4 px-2">
                                        <p className="text-sm font-bold text-gray-700 text-center">
                                            <span className="uppercase tracking-wide"> Mahindra</span>
                                            <span className="ml-1">475 DI</span>
                                            <br/>
                                            <Tooltip title="PTO Horsepower"><span className="">55HP</span></Tooltip>
                                            <span className="m-1">•</span>
                                            <Tooltip title="Drive type"><span className="">4WD</span></Tooltip>
                                        </p>
                                    </div>
                                </div>    
                            </div>

                        </div>
                    
                </div>
            </div>
            
        </div>
    );
}

export default StaticCompareTractors;
